export const SERVICE_ERROR_TEXTS = {
  title: 'En este momento no podemos atender tu solicitud',
  subtitle:
    'Lo sentimos, el servicio no se encuentra disponible.\nReintenta o ingresa más tarde.',
  subtitleWithoutRetries:
    'Lo sentimos, el servicio no se encuentra disponible.\nIngresa más tarde o intenta por otro medio.',
};
